import React, { useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import Container from "../../components/Layout/Container";
import AllDocuments from "./components/AllDocuments";
import NewDocuments from "./components/NewDocuments";
import PendingDocuments from "./components/PendingDocuments";

export const queryVVStockDocumentsClient = new QueryClient();

export default function VVStockDocumentsPage({ match }) {
    const [tabId, setTabId] = useState("all_documents");

    const renderTabContent = () => {
        switch (tabId) {
            case "all_documents":
                return <AllDocuments tabId={tabId} setTabId={setTabId} />;
            case "new_documents":
                return <NewDocuments tabId={tabId} setTabId={setTabId} />;
            case "pending_documents":
                return <PendingDocuments tabId={tabId} setTabId={setTabId} />;
            default:
                return null;
        }
    };

    const getLocation = () => {
        switch (tabId) {
            case "all_documents":
                return {
                    locationName: "All Documents",
                    locationUrl: match.url,
                };
            case "new_documents":
                return {
                    locationName: "New Documents",
                    locationUrl: match.url,
                };
            case "pending_documents":
                return {
                    locationName: "Pending Documents",
                    locationUrl: match.url,
                };
            default:
                return {
                    locationName: "Documents",
                    locationUrl: match.url,
                };
        }
    };

    const getBreadcrumbs = () => {
        const baseBreadcrumbs = [
            {
                label: "VV Stock",
                value: "/vv-stock",
            },
            {
                label: "Documents",
                value: match.url,
            },
        ];

        switch (tabId) {
            case "all_documents":
                return baseBreadcrumbs;
            case "new_documents":
                return [
                    ...baseBreadcrumbs,
                    {
                        label: "New Documents",
                        value: match.url,
                    },
                ];
            case "pending_documents":
                return [
                    ...baseBreadcrumbs,
                    {
                        label: "Pending Documents",
                        value: match.url,
                    },
                ];
            default:
                return baseBreadcrumbs;
        }
    };

    return (
        <Container location={getLocation()} breadcrumbs={getBreadcrumbs()}>
            <QueryClientProvider client={queryVVStockDocumentsClient}>
                {renderTabContent()}
            </QueryClientProvider>
        </Container>
    );
}
